import { url } from '../../../api/endpointURL';
import React, { useState } from 'react';

// error notification box
import './edit-modal.css';

// Import generic components
import Button from '../../../generic_components/Button/Button';
import Input from '../../../generic_components/Input/Input';
import { useToast } from '../../../generic_components/Toast/Toast';

const EditSIModal = ( {hwid, closeModal, business, setTableData, tableData} ) => {
    const [site, setSite] = useState('');
    const[loading, setLoading] = useState(false);

    const toast = useToast();

    const handleUpdateSite = async() => {
        try 
        {
            if (!site.trim()) {
                const errorMsg = `Please enter site name.`;
                // addToast(errorMsg, {
                //     appearance: 'error',
                //     autoDismiss: true,
                //     autoDismissTimeout: 9000 
                // });
                toast.error(errorMsg, {
                    hideProgressBar: true,
                    autoClose: 9000 
                });
                return;
            }
            const data = {hwid, site};
            setLoading(true);
            const response = await fetch(`${url}/edit-site`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();        
        
            if (result.code === 200) {          
                const successMsg = `Site name updated to ${site} successfully.`;
                // addToast(successMsg, {
                //     appearance: 'success',
                //     autoDismiss: true,
                //     autoDismissTimeout: 9000 
                // });
                toast.success(successMsg, {
                    hideProgressBar: true,
                    autoClose: 9000 
                });       
                // update setTableData with the new timezone
                const updatedTableData = tableData.map((item) => {
                    if (item.hwid === hwid) {
                        return { ...item, site: site };
                    }
                    return item;
                });
                setTableData(updatedTableData);
            }
            // add delay of 1 second before closing the modal
            await new Promise(resolve => setTimeout(resolve, 1000));   
            setLoading(false);    
            closeModal();       
        } 
        catch(error) 
        {
            setLoading(false);
            setSite('');
            console.log(`Error in updating site name : ${error}`);
            const errorMsg = `Interal server error, please try again later.`;
            // addToast(errorMsg, {
            //     appearance: 'error',
            //     autoDismiss: true,
            //     autoDismissTimeout: 9000    
            // });
            toast.error(errorMsg, {
                hideProgressBar: true,
                autoClose: 9000    
            });
        }
    }

    const handleSelectChange = (e) => {
        setSite(e.target.value.trim());
    }

  return (
    <div>
        <div className='modal-sites-body-title'>
            Enter a new site name for the business {business}:
        </div>
        
        <Input
            className='modal-sites-body-input'
            type='text'
            value={site}
            onChange={handleSelectChange} 
            placeholder='Enter Site Name...'
            required
            disabled={loading}
        />      
        <Button
            size='small'
            className='modal-sites-body-btn-submit'
            onClick={() => handleUpdateSite()}
            disabled={loading}  /* Disable when loading */
            >
            Update
        </Button>
        
        <div className='modal-sites-body-btn-loading-container'>
            { loading && (
                    <div className='loading-spinner'>
                        <div className="spinner-border modal-sites-body-loading-icon" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )
            }
        </div>        
       
    </div>
    

  )
}

export default EditSIModal